import { createEndpointKeyFromFormKeyAndAnswerId } from '../../../../helpers/registration-check'
import { Answer, Endpoint, Question, QuestionsFormData } from '../../../../types/questions'

/**
 * Filters and retrieves answers with endpoint notifications based on form data and question content.
 */
export const getActivityEndpoints = (
    formData: QuestionsFormData,
    formDataSelector: string,
    question: Question,
): Endpoint[] => {
    const matchingFormData = formData[formDataSelector]

    const answersWithEndpointNotification = question.questionContent.answers
        .filter((answer: Answer) => {
            if (!answer.result?.endpointNotification) {
                return false
            }

            if (Array.isArray(matchingFormData)) {
                return matchingFormData.includes(answer.id)
            } else {
                return answer.id === matchingFormData
            }
        })
        .map((answer) => ({
            ...answer,
            endpointKey: createEndpointKeyFromFormKeyAndAnswerId(formDataSelector, answer.id),
            startDate: null,
        }))

    return answersWithEndpointNotification
}
